import { render } from "./RatingsView.vue?vue&type=template&id=1b11e1cd&ts=true"
import script from "./RatingsView.vue?vue&type=script&lang=ts"
export * from "./RatingsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__